import { useQuery, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { UserRole } from '@/models/features/user.models'

export interface TimeBlockNoteAuthor {
  id: number
  firstName: string
  lastName: string
  avatar?: string
  role?: UserRole
}

export interface TimeBlockNote {
  id: number
  title: string
  noteBody: string
  createdAt: number
  createdBy: TimeBlockNoteAuthor | null
}

export const USE_GET_TIME_BLOCK_NOTES_QUERY_KEY = 'useGetTimeBlockNotes'

export const getTimeBlockNotesQueryKey = (timeBlockId?: number) => [
  USE_GET_TIME_BLOCK_NOTES_QUERY_KEY,
  timeBlockId,
]

export const getTimeBlockNotes = async (timeBlockId: number) => {
  // Note: explicit sort - the backend blueprint route has no default order, and the ticket
  // requires notes chronological oldest-first.
  const response = await authAPI.get<TimeBlockNote[]>(`/time-block/${timeBlockId}/notes`, {
    params: { sort: 'createdAt ASC' },
  })
  return response.data
}

export const useGetTimeBlockNotes = (timeBlockId?: number) =>
  useQuery({
    enabled: !!timeBlockId,
    queryFn: () => getTimeBlockNotes(timeBlockId!),
    queryKey: getTimeBlockNotesQueryKey(timeBlockId),
  })

export const useInvalidateTimeBlockNotes = () => {
  const queryClient = useQueryClient()
  return (timeBlockId?: number) =>
    queryClient.invalidateQueries({ queryKey: getTimeBlockNotesQueryKey(timeBlockId) })
}
